export default __webpack_public_path__ + "static/media/doctor2.86636edb.webp";